import { render, staticRenderFns } from "./CardProductionBoxComponent.vue?vue&type=template&id=2931add1&"
import script from "./CardProductionBoxComponent.vue?vue&type=script&lang=ts&"
export * from "./CardProductionBoxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports